import styled from 'styled-components';

import { Box } from '../../../atoms';
import { consentConfig } from '../config';
import { CookieConsentProps } from '../types';

export const SimplifiedContainer = styled(Box)<CookieConsentProps>`
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 100;
  gap: 24px;
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  right: ${({ right }) => right};
  background-color: ${consentConfig.bgColor};
  border-radius: 12px;
  padding: 12px 16px;
  max-width: 400px;
  width: max-content;

  @media (max-width: ${consentConfig.media.mobile}) {
    max-width: 350px;
    left: 16px;
    right: 16px;
  }
`;

export const Title = styled.h3`
  color: ${consentConfig.primaryTextColor};
  font-family: 'SF Pro Text';
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  margin-bottom: 2px;
`;

export const Subtitle = styled.p`
  color: ${consentConfig.secondaryTextColor};
  font-family: 'SF Pro Text';
  font-size: 12px;
  margin: 0;
`;

export const ManageLink = styled.button`
  background: none;
  border: none;
  color: #007aff;
  font-family: 'SF Pro Text';
  font-size: 12px;
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`;

export const AcceptButton = styled(Box)`
  font-size: 13px;
  width: max-content;
  border-radius: 8px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 42px;
`;
